const Questions = [
  {
    id: 0,
    question: "What is the total YooB's supply?",
    answer: "The Total supply is 10,000.",
  },
  {
    id: 1,
    question: "Where can I buy or sell my Yoobs?",
    answer: "You can mint them on our website or get them on secondary market.",
  },
  {
    id: 2,
    question: "Where can I buy HHUT$ token?",
    answer: "You can buy across multiple platforms.",
  },
  {
    id: 3,
    question: "Have More Questions?",
    answer: "Join our Discord.",
  },
];

export default Questions;
